<template>
  <SearchField
    v-for="searchField of searchFields"
    v-bind="$attrs"
    :key="searchField.searchQuery"
    :label="$t(searchField.label)"
    :search-query="searchField.searchQuery"
  />
</template>

<script setup lang="ts">
import SearchField from '@/components/common/lists/SearchField.vue'
import { TransientBaseObjectType } from '@/models/core/base'

interface SearchFieldsProps {
  modelClass: TransientBaseObjectType
}

const props = defineProps<SearchFieldsProps>()

const searchFields = props.modelClass.searchFields()
</script>

<style lang="scss"></style>
